<template>
  <transition name="el-zoom-in-top">
    <el-card class="box-card" style="text-align: left;" v-show="update.show">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>修改出库单</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="update.show=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form
        ref="update.form"
        :model="update.form"
        label-width="110px"
        style="width:100%"
        :rules="rules"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="运单号" prop="freightBillCode">
              <el-input v-model="update.form.freightBillCode" style="width:80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出库单号" prop="outBillCode">
              <el-input v-model="update.form.outBillCode" style="width:80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出库时间" prop="outBillTime">
              <el-date-picker
                style="width:80%"
                v-model="update.form.outBillTime"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="timestamp"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发货仓库" prop="fromWarehouseCode">
              <el-select
                v-model="update.form.fromWarehouseCode"
                placeholder="请选择"
                style="width:80%"
                @change="currentSel"
              >
                <el-option
                  v-for="item in fromWarehouse"
                  :key="item.warehouseUuid"
                  :label="item.warehouseName"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="经销商编码" prop="dealerCode">
              <el-cascader
                v-model="update.form.dealerCode"
                style="width:80%"
                placeholder="请输入经销商名称"
                filterable
                :props="elselectProps"
                :show-all-levels="true"
                :options="departtree"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <!-- 填写具体奖项 -->
        <h4>产品记录</h4>
        <br />
        <el-row>
          <el-col :span="11">
            <el-card shadow="never">
              <el-form
                ref="productform"
                :model="productform"
                label-width="110px"
                style="width:80%"
                :rules="rules"
              >
                <el-form-item label="产品" prop="productCode">
                  <el-select
                    v-model="productform.productCode"
                    placeholder="请输入产品名称"
                    style="width:60%"
                    :remote-method="getproductlist"
                    @change="getproductname($event)"
                    filterable
                    remote
                    :loading="productloading"
                  >
                    <el-option
                      v-for="item in productlist"
                      :key="item.product_code"
                      :label="item.product_name"
                      :value="item.product_code"
                    >
                    <span style="float: left">{{ item.product_code }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.product_name }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label=" 生产批次" prop="batchNo">
                  <el-input v-model="productform.batchNo" style="width:60%"></el-input>
                </el-form-item>-->
                <el-form-item label="计划出库数量" prop="planQuantity">
                  <el-input v-model.number="productform.planQuantity" style="width:60%"></el-input>
                </el-form-item>
                <el-form-item label="包装级别" prop="planPackageLevel">
                  <el-select
                    v-model="productform.planPackageLevel"
                    placeholder="请选择"
                    style="width:60%"
                  >
                    <el-option
                      v-for="item in package_levellist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button style="margin-top: 12px;" @click="resetForm('productform')">重置</el-button>
                <el-button
                  style="margin-top: 12px;"
                  type="primary"
                  @click="productadd('productform')"
                >生成</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align:center">
            <el-button size="medium" style="margin-top: 100px;" class="el-icon-d-arrow-right"></el-button>
          </el-col>
          <el-col :span="11">
            <el-card shadow="never">
              <el-table :data="update.tablelist" stripe style="width: 100%">
                <el-table-column
                  prop="productName"
                  label="产品名称"
                  show-overflow-tooltip
                  min-width="150"
                ></el-table-column>
                <el-table-column prop="productCode" label="产品编码" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="batchNo" label="生产批次" show-overflow-tooltip></el-table-column> -->
                <el-table-column prop="planQuantity" label="计划生产数量" min-width="100"></el-table-column>
                <el-table-column prop="address" label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button
                        type="danger"
                        @click.native.prevent="deleteRow(scope.$index, update.tablelist)"
                      >删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('update.form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import {
  updateoutbillorder,
  insertoutbillorderproduct,
  donloadoutbillorder
} from "@/api/physical";
import { productlist, productunitlist, maxlevelproduct } from "@/api/base";
import { departtree } from "@/api/orgin";
import { findwarehouse } from "@/api/query";
import { type } from "os";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    update: {
      type: Object,
      default: () => {
        return {
          show: false,
          form: {
            freightBillCode: null,
            outBillCode: null,
            outBillTime: null,
            fromWarehouseCode: null,
            fromWarehouse: null,
            dealerCode: null,
            remark:null
          },
          // 步骤2表格数据
          tablelist: []
        };
      }
    }
  },
  data() {
    return {
      //基础数据
      show: true,
      flag: true,
      productloading: false,
      departtree: null, // 掉接口返回部门树
      elselectProps: {
        children: "listSubWareHouses",
        label: "depart_name",
        value: "depart_code",
        id: "depart_uuid",
        checkStrictly: true
      },
      package_unit_code: [],
      productlist: [], //产品列表下拉
      fromWarehouse: [],
                  package_levellist: [
        {
          value: 1,
          label: '一级包装'
        },
        {
          value: 2,
          label: '二级包装'
        },
        {
          value: 3,
          label: '三级包装'
        },
         {
          value: 4,
          label: '四级包装'
        },
        {
          value: 5,
          label: '五级包装'
        },
      ],
      productform: {
        //步骤1 表单
        productCode: null,
        productName: null,
        batchNo: null,
        planQuantity: 0,
        planPackageLevel: null,
        produceTime: null,
        remark:null
      },
      rules: {
        freightBillCode: [
          { required: true, message: "请输入运单号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" }
        ],
        outBillCode: [
          { required: true, message: "请输入出库单号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" }
        ],
        outBillTime: [
          { required: true, message: "请输入出库时间", trigger: "blur" }
        ],

        fromWarehouseCode: [
          { required: true, message: "请选择仓库编码", trigger: "blur" }
        ],
        dealerCode: [
          { required: true, message: "请输入经销商编码", trigger: "blur" }
        ],
        productCode: [
          { required: true, message: "请选择产品", trigger: "blur" }
        ],
        planQuantity: [
          { required: true, message: "请输入计划生产数量", trigger: "blur" }
        ],
         planPackageLevel:[
          { required: true, message: "请选择包装单位", trigger: "blur" }
        ],
        // batchNo: [
        //   { required: true, message: "请输入生产批次", trigger: "blur" },
        //   { validator:this.$validateaccount, trigger: "blur" },
        // ]
      }
    };
  },
  mounted() {
    this.getdeparttree();
    this.getproductlist();
    this.getfromWarehouse();
    // this.unitcode();
  },
  methods: {
    currentSel(e) {
      this.form.fromWarehouseCode = e.warehouseName;
      this.form.fromWarehouse = e.warehouseName.split("|")[1];
    },
    // unitcode(name) {
    //   this.package_unit_code = [];
    //   this.productform.planPackageLevel = "";
    //   if (name !== undefined) {
    //     maxlevelproduct({
    //       product_code: name
    //     }).then(res => {
    //       this.package_unit_code = [
    //         {
    //           value: res.data.package_level,
    //           label: res.data.package_level
    //         }
    //       ];
    //     });
    //   }
    // },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var opt = {};
          opt.productName = this.productform.productName;
          opt.productCode = this.productform.productCode;
          opt.planQuantity = this.productform.planQuantity;
          opt.planPackageLevel = this.productform.planPackageLevel;
          this.update.tablelist.push(opt);
          console.log(this.tablelist);
          this.$refs[formName].resetFields();
        } else {
          return false;
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    getproductname(e) {
      let obj = {};
      this.flag = false;
      obj = this.productlist.find(item => {
        return item.product_code === e; //筛选出匹配数据
      });
      this.productform.productName = obj.product_name;
      // this.unitcode(e);
    },
    // 获取产品下拉
    getproductlist(value) {
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    // 根据仓库编码获取名称
    getfromWarehouse(value) {
      findwarehouse({ warehouseCode: value }).then(response => {
        this.fromWarehouse = response.data;
      });
    },
    // //请求部门树结构
    getdeparttree() {
      departtree({ departType: 3 }).then(response => {
        this.departtree = this.getTreeData(response.data);
      });
    },
    getTreeData(data) {
      // 去除树空子集
      for (var i = 0; i < data.length; i++) {
        if (data[i].listSubWareHouses.length < 1) {
          data[i].listSubWareHouses = undefined;
        } else {
          this.getTreeData(data[i].listSubWareHouses);
        }
      }
      return data;
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          this.update.form.dealerCode = this.update.form.dealerCode[
            this.update.form.dealerCode.length - 1
          ];
          updateoutbillorder({
            outBillCode: this.update.form.outBillCode,
            freightBillCode: this.update.form.freightBillCode,
            outBillTime: this.update.form.outBillTime,
            fromWarehouseCode: this.update.form.fromWarehouseCode.split("|")[0],
            fromWarehouse: this.update.form.fromWarehouse,
            dealerCode: this.update.form.dealerCode,
            remark:this.update.form.remark,
            orderProductsEntityList: this.update.tablelist
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "提交成功!"
              });
              this.search();
              this.update.tablelist = [];
              this.resetForm(formName);
            } else {
              this.$message({
                type: "warning",
                message: "提交失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.flag = true;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
